import { SVGProps } from 'react'

export function TickmillLogoIcon(props: SVGProps<SVGSVGElement>) {
  const { width = 80, height = 80 } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 129 128'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M73.0576 93.2398H51.9052C49.3473 93.2398 46.961 91.8641 45.6925 89.65L33.5473 68.6053C32.2575 66.3911 32.2575 63.6393 33.5473 61.4252L45.6925 40.3805C46.9824 38.1664 49.3473 36.7906 51.9052 36.7906H73.0362L89.8249 7.70609C89.4593 7.68459 89.1154 7.6416 88.7498 7.6416H39.3513C34.1277 7.6416 29.3126 10.4146 26.7115 14.9503L2.01232 57.7282C-0.588744 62.2423 -0.588744 67.8096 2.01232 72.3241L26.7115 115.102C29.3126 119.616 34.1492 122.41 39.3513 122.41H88.7498C89.1154 122.41 89.4806 122.368 89.8462 122.346L73.0576 93.2616V93.2398Z'
        fill='#FF0044'
      />
      <path
        d='M126.11 57.7275L101.411 14.9497C101.218 14.6273 101.003 14.3478 100.809 14.0469L84.0205 43.1313L94.5969 61.4463C95.8868 63.6604 95.8868 66.4118 94.5969 68.6259L84.0205 86.9192L100.809 116.004C101.003 115.703 101.239 115.423 101.411 115.101L126.11 72.3234C128.711 67.8093 128.711 62.2416 126.11 57.7275Z'
        fill='#28F981'
      />
    </svg>
  )
}
